(() => {
  'use strict';
  const initialize = (scope = document) => {
    scope.querySelectorAll('.fc-editorial:not([data-ed-initialized])').forEach(root => {
      root.dataset.edInitialized = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (root.matches('.ed-care')) {
        const mobile = window.matchMedia('(max-width: 749px)');
        const paths = [...root.querySelectorAll('[data-care-path]')];
        const panels = [...root.querySelectorAll('[data-care-panel]')];
        const synchronize = () => {
          const selected = location.hash === '#coat' ? 'coat' : 'surfaces';
          root.dataset.care = selected;
          root.dataset.enhanced = 'true';
          paths.forEach(path => {
            if (path.dataset.carePath === selected) path.setAttribute('aria-current', 'true');
            else path.removeAttribute('aria-current');
          });
          panels.forEach(panel => { panel.dataset.inactive = String(panel.dataset.carePanel !== selected); });
        };
        paths.forEach(path => path.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (!mobile.matches) return;
          event.preventDefault();
          const hash = '#' + path.dataset.carePath;
          if (location.hash !== hash) history.pushState(null, '', hash);
          synchronize();
          // The activated path stays in place; selection and content update together.
        }));
        window.addEventListener('popstate', synchronize);
        window.addEventListener('hashchange', synchronize);
        mobile.addEventListener('change', synchronize);
        synchronize();
      }
      if (root.matches('.ed-article') && 'IntersectionObserver' in window) {
        const links = [...root.querySelectorAll('.ed-toc-desktop a')];
        const headings = links.map(link => root.querySelector(link.getAttribute('href'))).filter(Boolean);
        if (links[0]) links[0].setAttribute('aria-current', 'true');
        const observer = new IntersectionObserver(entries => {
          const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (!visible.length) return;
          links.forEach(link => {
            if (link.hash === '#' + visible[0].target.id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        }, {rootMargin: '-100px 0px -55% 0px', threshold: 0});
        headings.forEach(heading => observer.observe(heading));
      }
      // Progressive, non-blocking motion: never CSS-hide content while waiting for JS.
      if (!reduceMotion.matches && 'IntersectionObserver' in window && typeof Element.prototype.animate === 'function') {
        const reveal = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            reveal.unobserve(entry.target);
            if (reduceMotion.matches) return;
            entry.target.animate([{transform: 'translateY(6px)'}, {transform: 'translateY(0)'}], {duration: 220, easing: 'ease-out'});
          });
        }, {threshold: .08});
        root.querySelectorAll('.ed-resource-band,.ed-story-principles,.ed-story-real').forEach(section => reveal.observe(section));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
